import React, { useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router';
import SessionService from '../../services/sessions';
import Progress from '../Util/Progress';
import SessionUploadPage from './SessionUploadPage';
import useSession from '../Util/useSession';

type TParams = {
  session: string;
  step?: string;
};

interface Props extends RouteComponentProps<TParams> {}

const SessionUploadFlow = (props: Props) => {
  const { match, history } = props;
  const creatingRef = useRef(false);
  const sessionId = match.params.session;
  const { session } = useSession(sessionId);

  useEffect(() => {
    const ensureSessionCreated = async () => {
      if (creatingRef.current) return;

      if (!sessionId) {
        try {
          creatingRef.current = true;
          const data = await SessionService.createSession({});
          const newId = data?.id;
          if (!newId) {
            console.error('Session create succeeded but no id returned', data);
            return;
          }
          history.replace(`/session/upload/${newId}`);
        } catch (err) {
          console.error('Error creating a new session', err);
        } finally {
          creatingRef.current = false;
        }
      }
    };

    ensureSessionCreated();
  }, [sessionId, history]);

  if (!sessionId) {
    return <Progress />;
  }

  return <SessionUploadPage sessionid={sessionId} duplicatedFromId={session?.duplicatedFromId ?? null} />;
};

export default SessionUploadFlow;
